$(function () {
    $('.shopFilters--show').on('click', function (e) {
        e.preventDefault();
        $('.shopFilters--show').parents('.col').addClass('d-none');
        $('.shopFilters--hide').parents('.col').removeClass('d-none');
        $('.shopFilters--wrapper, .shopFilters--heading').removeClass('d-none');
    });
    $('.shopFilters--hide').on('click', function (e) {
        e.preventDefault();
        $('.shopFilters--hide').parents('.col').addClass('d-none');
        $('.shopFilters--show').parents('.col').removeClass('d-none');
        $('.shopFilters--wrapper, .shopFilters--heading').addClass('d-none');
    });

    $('#ExistingAddressesDD').on('change', function (e) {
        if ($('#ExistingAddressesDD').val() != "0") {
            $('.address-name').val($('#ExistingAddressesDD option:selected').data('name'));
            $('.address-line1').val($('#ExistingAddressesDD option:selected').data('line1'));
            $('.address-line2').val($('#ExistingAddressesDD option:selected').data('line2'));
            $('.address-towncity').val($('#ExistingAddressesDD option:selected').data('towncity'));
            $('.address-postcode').val($('#ExistingAddressesDD option:selected').data('postcode'));
        } else {
            $('.address-name').val('');
            $('.address-line1').val('');
            $('.address-line2').val('');
            $('.address-towncity').val('');
            $('.address-postcode').val('');
        }
    });

    $('.shopFilters').on('change', '[name="option"]', function () {
        var options = $('.shopFilters [name="option"]:checked').map(function () {
            return this.value;
        }).get();

        if (options.length > 0) {
            $('.productPreview').addClass('d-none');
            options.forEach(function (option) {
                $('.productPreview[data-option="' + option + '"]').removeClass('d-none');
            });
        } else {
            $('.productPreview').removeClass('d-none');
        }
        $('.lazy').Lazy();
    }).on('change', '[name="sort"]', function () {
        var wrapper = $('.productPreview--wrapper'), products = wrapper.children('.productPreview');
        switch ($('[name="sort"]').val()) {
            case 'price-low':
                products.detach().sort(function (a, b) {
                    return $(a).data('price') - $(b).data('price');  
                });
                break;
            case 'price-high':
                products.detach().sort(function (a, b) {
                    return $(b).data('price') - $(a).data('price');
                });
                break;
            default:
                products.detach().sort(function (a, b) {
                    return $(a).data('position') - $(b).data('position');
                });
                break;
        }

        wrapper.append(products);
        $('.lazy').Lazy();
    });

    if ($('.shopFilters').length > 0 && document.URL.indexOf('#') >= 0) {
        $('.shopFilters--show').trigger('click');
        var hashtags = document.URL.substr(document.URL.indexOf('#') + 1).split("|");
        $.each(hashtags, function (index, value) {
            switch (value) {
                case "Mens":
                    $('.shopFilters [name="option"][value="1"]').prop('checked', true).trigger('change');
                    break;
                case "Womens":
                    $('.shopFilters [name="option"][value="2"]').prop('checked', true).trigger('change');
                    break;
                case "HisHers":
                    $('.shopFilters [name="option"][value="3"]').prop('checked', true).trigger('change');
                    break;
            }
        });
    }

    $('.RemoveProduct').on('click', function (e) {
        e.preventDefault();

        var target = $(this).attr('href');
        var selectedProduct = $.parseJSON($(this).siblings('.shop-product-data').text());
        var qty = $(this).siblings('.ProductQuantityControl').find('.ProductQuantityControl--input').val();

        gtag('event', 'remove_from_cart', {
            'items': [
                {
                    'id': selectedProduct.gaId,
                    'name': selectedProduct.gaName,
                    'price': selectedProduct.gaPrice,
                    'quantity': qty
                }
            ],
            'event_callback': createFunctionWithTimeout(function () {
                window.location = target;
            })
        });
    });
});